/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedCreator_relatedCreators = {
    readonly shopAllTitle: string | null;
    readonly creatorName: string | null;
    readonly linkData: {
        readonly path: string | null;
        readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
    };
    readonly items: ReadonlyArray<{
        readonly title?: string | null;
        readonly localizedPdpUrl?: string | null;
        readonly photos?: ReadonlyArray<{
            readonly smallPath: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "SbSharedRelatedCreator_relatedCreators";
};
export type SbSharedRelatedCreator_relatedCreators$data = SbSharedRelatedCreator_relatedCreators;
export type SbSharedRelatedCreator_relatedCreators$key = {
    readonly " $data"?: SbSharedRelatedCreator_relatedCreators$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRelatedCreator_relatedCreators">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRelatedCreator_relatedCreators",
  "type": "RelatedCreatorType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "shopAllTitle",
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": "creatorName",
      "name": "pageObjectName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "linkData",
      "storageKey": null,
      "args": null,
      "concreteType": "LinkData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "path",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData",
          "args": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": null,
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "Item",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "localizedPdpUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "photos",
              "storageKey": "photos(limit:1)",
              "args": [
                {
                  "kind": "Literal",
                  "name": "limit",
                  "value": 1
                }
              ],
              "concreteType": "ItemPhoto",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "smallPath",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '491547dfb689999bc9e77420e4d785c4';
export default node;
